import { coreRequestService } from '../index';

export const authDelete = () => coreRequestService({
    url: '/auth',
    method: 'DELETE'
});
